<div class="loading" [class.active]="loadingService.active" aria-live="polite" [attr.aria-busy]="loadingService.active">
    <img src="assets/loading.gif" alt="Carregando...">
</div>
